import { DevicePreview } from "@givenwell/device-preview";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/demo")({
  component: DemoComponent,
  validateSearch: object({
    path: fallback(optional(string(), "/"), "/"),
  }),
});

function DemoComponent() {
  const { path } = Route.useSearch();
  const [initialPath] = useState(path);
  const origin = window.location.origin;

  const navigate = Route.useNavigate();

  return (
    <DevicePreview
      origin={origin}
      initialPath={initialPath}
      onPathChange={nextPath => {
        navigate({
          search: prev => ({
            ...prev,
            path: nextPath,
          }),
          replace: true,
        });
      }}
    />
  );
}
